import { render, staticRenderFns } from "./PHome.vue?vue&type=template&id=637cf847&scoped=true&"
import script from "./PHome.vue?vue&type=script&lang=js&"
export * from "./PHome.vue?vue&type=script&lang=js&"
import style0 from "./PHome.vue?vue&type=style&index=0&id=637cf847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637cf847",
  null
  
)

export default component.exports